module.exports = __webpack_public_path__ + "static/media/st-lucia.57547d01.png";